var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prefix-code-picker",on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"code-text"},[_vm._v(_vm._s(_vm.code))]),_c('img',{staticClass:"arrow-icon",attrs:{"src":require("@/assets/images/icon_arrow.png")}}),_c('div',{staticClass:"v-divider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }